"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YbugProvider = exports.useYbugApi = void 0;
const React = __importStar(require("react"));
const YbugContext = React.createContext(null);
function useYbugApi() {
    return React.useContext(YbugContext);
}
exports.useYbugApi = useYbugApi;
function YbugProvider({ ybugId, url, children, settings }) {
    const YBUG_DEFAULT_SCRIPT_URL = `https://widget.ybug.io/button/${ybugId}.js`;
    const [ybugApi, setYbugApi] = React.useState(null);
    React.useEffect(() => {
        // @ts-expect-error will not be defined in window
        window.ybug_settings = Object.assign(Object.assign({}, settings), { id: ybugId, onload: () => {
                var _a;
                // @ts-expect-error will not be defined in window
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setYbugApi(window.Ybug);
                (_a = settings === null || settings === void 0 ? void 0 : settings.onload) === null || _a === void 0 ? void 0 : _a.call(settings);
            } });
        const script = document.createElement('script');
        script.defer = true;
        script.src = url !== null && url !== void 0 ? url : YBUG_DEFAULT_SCRIPT_URL;
        if (settings === null || settings === void 0 ? void 0 : settings.nonce) {
            script.nonce = settings.nonce;
        }
        document.head.appendChild(script);
        return () => {
            if (ybugApi) {
                ybugApi.destroy();
            }
            script.remove();
        };
    }, []);
    const initYbug = (settings) => {
        // @ts-expect-error will not be defined in window
        window.ybug_settings = Object.assign(Object.assign({}, settings), { id: ybugId, onload: () => {
                var _a;
                // @ts-expect-error will not be defined in window
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setYbugApi(window.Ybug);
                (_a = settings === null || settings === void 0 ? void 0 : settings.onload) === null || _a === void 0 ? void 0 : _a.call(settings);
            } });
        if (ybugApi) {
            ybugApi.destroy();
            ybugApi.boot();
        }
    };
    return React.createElement(YbugContext.Provider, { value: { Ybug: ybugApi, init: initYbug } }, children);
}
exports.YbugProvider = YbugProvider;
